import { type Theme, css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
} from '@twistopayments/design-system/styles'

export const primaryContainer = css`
  display: grid;
  grid-row-gap: ${size[20]};
  padding: 0 ${size[24]};
  margin: ${size[24]} 0;
`

export const secondaryContainer = css`
  display: grid;
  width: 100%;
  justify-items: stretch;
  grid-row-gap: ${size[16]};
  padding: 0 ${size[24]};
  margin: 0;

  ${breakpoint.down('lg')} {
    a {
      width: 100%;
    }
  }
`

export const sectionsContainer = css`
  margin: 0;
  padding: 0 ${size[24]};
`

export const sectionItem = css`
  margin: 0 0 ${size[12]};
`

export const sectionTitle = (theme: Theme) => css`
  margin: 0 0 ${size[18]};
  padding: ${size[12]} 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid ${theme.palette.tertiary.mediumContrast};
  font-size: ${fontSize.lg};
  font-weight: 700;

  svg {
    fill: ${theme.palette.tertiary.mediumContrastAlternative};
  }
`

export const sectionContent = css`
  display: none;
`

export const openSectionContent = css`
  display: block;
`

export const pagesList = (theme: Theme) => css`
  margin: 0 0 ${size[8]};
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${size[8]};
  font-size: ${fontSize.smMd};

  a {
    color: ${theme.palette.tertiary.upperMediumContrast};
    text-decoration: none;
  }
`

export const folderName = css`
  margin: ${size[8]} 0;
  font-size: ${fontSize.sm};
  font-weight: 500;
`
